import {
    AddDictionaryEntryRequest,
    EmployeeDictionaryEntryDto,
    EmployeeDictionaryType,
    UpdateDictionaryEntryRequest,
} from '../../../models/employeeHub';
import { BackendHttpService } from '../../../services/backendHttpService';

class EmployeeDictionaryService extends BackendHttpService {
    constructor() {
        super('api/employee-dictionaries');
    }

    getAll(type: EmployeeDictionaryType): Promise<EmployeeDictionaryEntryDto[]> {
        return this.get<EmployeeDictionaryEntryDto[]>(`/${type}`);
    }

    update(type: EmployeeDictionaryType, id: number, payload: UpdateDictionaryEntryRequest): Promise<void> {
        return this.put<UpdateDictionaryEntryRequest, void>(payload, `/${type}/${id}`);
    }

    add(type: EmployeeDictionaryType, payload: AddDictionaryEntryRequest): Promise<EmployeeDictionaryEntryDto> {
        return this.post<AddDictionaryEntryRequest, EmployeeDictionaryEntryDto>(payload, `/${type}`);
    }
}

export const employeeDictionaryService = new EmployeeDictionaryService();
